<template>
    <div class="pop-up__openApp">
        <img src="/img/icons/pctoapp.svg" width="177" alt="">
        <p>{{ $t('driver_onboarding.open_app')}}</p>
        <a href="https://smarturl.it/ahamove.driver" target="_blank">{{ $t('driver_onboarding.open_app_button')}}</a>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.pop-up__openApp{
    padding: 25px 15px;
    width: 100%;
    text-align: center;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    p{
      color: #1A1A1A;
      font-weight: 500;
      margin: 25px 0;
    }
    a{
      background: #ff8200;
      color: white;
      padding: 10px 25px;
      border-radius: 4px;
      font-weight: 500;
    }
}
</style>>
